<section class="about-board" [attr.aria-label]="'ABOUT-US_BOARD-HEADING' | translate">
  <app-loader [loading]="state === 'loading'"></app-loader>

  <p class="about-board__message" *ngIf="state === 'error'" role="alert">
    {{ 'ABOUT-US_BOARD-ERROR' | translate }}
  </p>

  <p class="about-board__message" *ngIf="state === 'empty'">
    {{ 'ABOUT-US_BOARD-EMPTY' | translate }}
  </p>

  <div
    class="about-board__wordpress"
    *ngIf="state === 'content'"
    [innerHTML]="content"
    (click)="onWordpressClick($event)"
  ></div>
</section>
